import { INITIAL_PRICES, INITIAL_TOTAL } from "./consts";
import {
  Calculation,
  CalculationDetail,
  CalculationDetailItem,
  CalculationDetailItemType,
  CalculationEditFormValues,
  CalculationPrices,
  CalculationRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION
-----------------------------------------------------------------------------------------*/
export const transformCalculation = (res: any): Calculation => {
  return {
    id: res.id,
    name: res.name,
  };
};


/*---------------------------------------------------------------------------------------
  CALCULATION SEARCH
-----------------------------------------------------------------------------------------*/
export const transformCalculationRow = (res: any): CalculationRow => {
  return {
    id: res.id,
    name: res.name,
    picture: res.picture,
    rentMonths: res.rentMonths,
    rentKm: res.rentKm,
    totalPrice: res.totalPrice,
    vehicleManufacturer: res.vehicleManufacturer,
    vehicleModel: res.vehicleModel,
    vehicleType: res.vehicleType,
  };
};



/*---------------------------------------------------------------------------------------
  CALCULATION DETAIL VIEW
-----------------------------------------------------------------------------------------*/
const transformCalculationDetailItemType = (
  res: any
): CalculationDetailItemType | null => {
  if (!res) return null;
  return {
    id: res.id ?? null,
    name: res.name ?? null,
    description: res.description ?? null,
    displayOrder: res.displayOrder ?? null,
    parent: transformCalculationDetailItemType(res.calculationItemTypeParent),
  };
};

const transformCalculationDetailItem = (res: any): CalculationDetailItem => {
  return {
    id: res.id ?? null,
    price: res.price ?? null,
    description: res.description ?? null,
    type: transformCalculationDetailItemType(res.calculationItemType),
  };
};

export const transformCalculationDetail = (res: any): CalculationDetail => {
  return {
    id: res.id,
    name: res.name ?? null,
    picture: res.picture ?? null,
    rentMonths: res.rentMonths ?? null,
    rentKm: res.rentKm ?? null,
    totalPrice: res.totalPrice ?? null,
    manufacturer: res.manufacturer ?? null,
    model: res.model ?? null,
    type: res.type ?? null,
    vehicleId: res.vehicle?.id ?? null,
    items: (res.items ?? []).map(transformCalculationDetailItem),
  };
};


/*---------------------------------------------------------------------------------------
  CALCULATION CREATE
  Šalje cijeli izračun: vozilo + period/km + odabir leasinga + sve stavke razrade.
  Po stavci šalje { initial, value } — initial je konstanta iz INITIAL_PRICES,
  value je trenutni (možda izmijenjeni) iznos iz form state-a. Backend usporedbom
  initial !== value zna je li korisnik tu stavku mijenjao.
  initialTotal = suma INITIAL_PRICES; total = aktualna suma form vrijednosti.
-----------------------------------------------------------------------------------------*/
export const transformCalculationOnCreate = (
  formValues: CalculationEditFormValues
): any => {
  const priceKeys = Object.keys(formValues.prices) as (keyof CalculationPrices)[];

  const prices = priceKeys.reduce(
    (acc, key) => {
      acc[key] = {
        initial: INITIAL_PRICES[key],
        value: formValues.prices[key],
      };
      return acc;
    },
    {} as Record<keyof CalculationPrices, { initial: number; value: number }>
  );

  const total = Object.values(formValues.prices).reduce(
    (sum, value) => sum + value,
    0
  );

  return {
    name: formValues.name,
    vehicleManufacturerId: formValues.vehicleManufacturerId,
    vehicleModelId: formValues.vehicleModelId,
    vehicleTypeId: formValues.vehicleTypeId,
    rentMonths: formValues.rentMonths,
    rentKm: formValues.rentKm,
    leasingId: formValues.leasingId,
    prices,
    initialTotal: INITIAL_TOTAL,
    total,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION EDIT
-----------------------------------------------------------------------------------------*/
export const transformCalculationOnUpdate = (
  formValues: CalculationEditFormValues
): any => ({
  id: formValues.id,
  ...transformCalculationOnCreate(formValues),
});
